import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { SWRConfig } from 'swr';
import Archive from './pages/Archive';
import Detail from './pages/Detail';
import NotFound from './pages/NotFound';
import Top from './pages/Top';

const App: React.FC = () => {
  return (
    <SWRConfig
      value={{
        refreshInterval: 180000,
        dedupingInterval: 180000,
      }}>
      <Router basename={process.env.REACT_APP_DIRECTORY}>
        <Routes>
          <Route path="/" element={<Top />} />
          <Route path="/:serviceId/" element={<Detail />} />
          <Route path="/archive/:categoryId/" element={<Archive />} />
          <Route path="/archive/:categoryId/:serviceId/" element={<Archive />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </SWRConfig>
  );
};

export default App;
